import type { IntervalName } from './intervals';

/**
 * Scale mode names array
 */
export const modeNames = [
  'Major',
  'naturalMinor',
  'harmonicMinor',
  'melodicMinorAscending',
  'melodicMinorDescending',
] as const;

/**
 * Scale mode names type
 */
export type ModeName = typeof modeNames[number];

export function isModeName(mode: string): mode is ModeName {
  return modeNames.includes(mode as ModeName);
}

/**
 * Dictionary of intervals between notes for scale modes.
 */
export const scaleIntervals: Record<ModeName, IntervalName[]> = {
  Major: ['M2', 'M2', 'm2', 'M2', 'M2', 'M2', 'm2'],
  naturalMinor: ['M2', 'm2', 'M2', 'M2', 'm2', 'M2', 'M2'],
  harmonicMinor: ['M2', 'm2', 'M2', 'M2', 'm2', 'A2', 'm2'],
  melodicMinorAscending: ['M2', 'm2', 'M2', 'M2', 'M2', 'M2', 'm2'],
  melodicMinorDescending: ['M2', 'm2', 'M2', 'M2', 'm2', 'M2', 'M2'],
};
